import type { CurrentUser } from "@/lib/auth";
import {
  fetchMeGroups,
  userHasGroup,
  userIsAbrechnung,
  userIsBuero,
  userIsManagement,
  isManagementGroupLabel,
} from "@/lib/auth";

export interface TimesheetPermissions {
  canManage: boolean;
  canArchive: boolean;
  canRevision: boolean;
  /** Abrechnungs-Aktionen (Zuweisen, Rückfrage, Rechnung, Gesehen). */
  canBilling: boolean;
  /** Tab „Abrechnung & Rückfragen“ (Abrechnung + Geschäftsführung). */
  canViewBillingTab: boolean;
  /** Rückfragen beantworten (Geschäftsführung). */
  canAnswerBillingQuestions: boolean;
}

export async function resolveTimesheetPermissions(
  user: CurrentUser | null,
): Promise<TimesheetPermissions> {
  const groups = await fetchMeGroups();
  const groupLower = groups.map((g) => String(g).toLowerCase());

  const isAdmin = userHasGroup(user, "App-Admins");
  const isMontage = groupLower.some((g) => g.includes("montage") || g.includes("monteur"));
  const isBuero = userIsBuero(user) || groupLower.some((g) => g.includes("büro") || g.includes("buero"));
  const isAbrechnung = userIsAbrechnung(user) || groupLower.some((g) => g.includes("abrechnung"));
  const isManagement =
    userIsManagement(user) || groups.some((group) => isManagementGroupLabel(group));

  return {
    canManage: isAdmin || isMontage || isBuero || isAbrechnung,
    canArchive: isAdmin || isBuero || isAbrechnung,
    canRevision: isAdmin || isBuero || isAbrechnung,
    canBilling: isAdmin || isAbrechnung,
    canViewBillingTab: isAdmin || isAbrechnung || isManagement,
    canAnswerBillingQuestions: isAdmin || isManagement,
  };
}
